// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kp-6";
export var emphasizeQuantity = "_kp-3";
export var flatBottomCorners = "_kp-5";
export var productImage = "_kp-0";
export var quantityContainer = "_kp-2";
export var tooltip = "_kp-1";
export var wrapAndEllipsesOverflow = "_kp-4";